import {
  Button,
  Row,
  Form,
  Input,
  Space,
  Table,
  Col,
  Tooltip,
  Menu,
  Dropdown,
  MenuProps,
  Empty,
  ConfigProvider,
  Modal,
  Checkbox,
} from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import { CommonStore, APoolStore, UserAccountStore } from "../../../../store";
import UpdateOrAdd from "./update_or_add";
import {
  InfoCircleOutlined,
  DownOutlined,
  MoreOutlined,
} from "@ant-design/icons";

const { Column } = Table;

function PoolAAllocation(props: any) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ name: "" });
    resetSearchbth();
  }, []);
  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    APoolStore.setSearchForm({ ...allValues });
  };

  const searchBtn = () => {
    APoolStore.resetPage();
    APoolStore.manageAPoolPage();
  };
  const resetSearchbth = () => {
    APoolStore.setSearchForm({});
    searchBtn();
  };

  const addPower = (data?: any) => {
    if (data) {
      UserAccountStore.addOrUpdateModal.open("update", data);
    } else {
      UserAccountStore.addOrUpdateModal.open("add");
    }
  };

  const items = [
    {
      label: "单个新增",
      key: "1",
      style: { display: CommonStore.pagePermission.manageable ? "" : "none" },
      // show: CommonStore.pagePermission.manageable,
    },
  ];

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return addPower();
    }
  };
  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return APoolStore.deletePower(record.no);
    } else if (e.key === "2") {
      return APoolStore.changeIsEnable(record.isEnable, record.no);
    } else if (e.key === "3") {
      return APoolStore.showModal(record.no);
    }
  };
  const moreOperations = (record: any) => {
    return [
      {
        label: "删除号池",
        key: "1",
        style: { color: "red", display: record.manageable ? "" : "none" },
        // show: CommonStore.pagePermission.manageable,
      },
      {
        label: record.isEnable ? "禁用" : "启用",
        key: "2",
        style: {
          color: record.isEnable ? "red" : "",
          display: record.manageable ? "" : "none",
        },
      },
      {
        label: "权限详情",
        key: "3",
      },
    ];
  };
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      <UpdateOrAdd></UpdateOrAdd>
      <div className="formContent">
        <Form
          form={form}
          initialValues={APoolStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="号池名称" name="name">
                <Input placeholder="请输入号池名称" />
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={resetSearchbth}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {CommonStore.pagePermission.manageable && (
              <Col span={8} offset={16} style={{ marginBottom: "10px" }}>
                <Dropdown
                  menu={{ items }}
                  dropdownRender={(menu) => (
                    <Menu onClick={handleMenuClick} items={items}></Menu>
                  )}
                >
                  <Button style={{ float: "right" }}>
                    <Space className="change">
                      变更
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Col>
            )}
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={APoolStore.tableData.records}
          rowKey={(record: { no: string }) => record.no}
          loading={APoolStore.tableLoad}
          scroll={{ x: 1400 }}
          pagination={{
            current: APoolStore.pageData.page,
            pageSize: APoolStore.pageData.size,
            onChange: APoolStore.pageData.changePage,
            pageSizeOptions: [10, 25, 50],
            showSizeChanger: true,
            total: APoolStore.tableData.total,
            showTotal: () => `共计${APoolStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          
          <Column
            fixed="left"
            ellipsis={true}
            width={160}
            title="号池名称"
            dataIndex="name"
          />
          <Column
            width={120}
            title="编号"
            dataIndex="no"
            render={(no) => (
              <Tooltip placement="topLeft" title={no}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          />
          <Column
            ellipsis={true}
            width={120}
            title="码号数量"
            dataIndex="count"
          />
          <Column
            title="状态"
            width={120}
            ellipsis={true}
            dataIndex="isEnable"
            render={(isEnable) => (isEnable ? "启用" : "禁用")}
          />
          <Column
            title="创建人"
            width={150}
            ellipsis={true}
            dataIndex="creator"
          />
          <Column
            title="创建时间"
            width={200}
            dataIndex="createTime"
            ellipsis={true}
          />
          <Column
            title="更新时间"
            width={200}
            dataIndex="updateTime"
            ellipsis={true}
          />
          <Column
            width={120}
            fixed={"right"}
            render={(text: string, record: any) => (
              <Space>
                {record.writeable && (
                  <Button size={"small"} onClick={() => addPower(record)}>
                    编辑
                  </Button>
                )}
                <Dropdown
                  // {...moreOperations}
                  dropdownRender={(menu) => (
                    <Menu
                      onClick={(e) => moreOperationsClick(e, record)}
                      className={"menuSty"}
                      items={moreOperations(record)}
                    ></Menu>
                  )}
                >
                  <Button size={"small"}>
                    <MoreOutlined />
                  </Button>
                </Dropdown>
              </Space>
            )}
          />
        </Table>
      </ConfigProvider>
      <Modal
        width={"60%"}
        title="权限详情"
        centered
        onCancel={APoolStore.hideModal}
        open={APoolStore.open}
        loading={APoolStore.modalLoading}
        onOk={APoolStore.hideModal}
        className="permissionDetail"
        footer={[
          <Button key="submit" onClick={APoolStore.hideModal}>
            关闭
          </Button>,
          <div
            key={"tips"}
            style={{ fontSize: "10px", marginTop: "10px", color: "#a6a8ab" }}
          >
            权限详情展示内容为用户或用户组对号池的操作权限（仅展示当前登录用户可查看的用户或用户组）
          </div>,
        ]}
      >
        <ConfigProvider renderEmpty={tableEmptyRender}>
          <Table
            dataSource={APoolStore.poolDetailData}
            rowKey={(record: { no: string }) => record.no}
            loading={APoolStore.tableLoad}
            scroll={{ x: 800 ,y: 'calc(100vh - 345px)'}}
            style={{padding:'10px'}}
            size="small"
            pagination={false}
          >
            <Column
              width={100}
              ellipsis={true}
              title="主体名称"
              align="center"
              render={(record) => (
                <Tooltip placement="topLeft">
                  {record.type === "account"
                    ? record.displayName
                    : record.displayName + "(用户组)"}
                </Tooltip>
              )}
            />
            {Object.keys(APoolStore.arrayTranslation).map((item, index) => {
              return (
                <Column
                  ellipsis={true}
                  width={120}
                  key={index}
                  title={APoolStore.arrayTranslation[item]}
                  align="center"
                  render={(record) => {
                    return (
                      <Checkbox
                        checked={record[item]}
                        disabled={true}
                      ></Checkbox>
                    );
                  }}
                />
              );
            })}
          </Table>
        </ConfigProvider>
      </Modal>
    </Fragment>
  );
}

export default observer(PoolAAllocation);
